import { useAuth } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { CacheWarmer } from '../features/sync/CacheWarmer';
import { SyncEngine } from '../features/sync/SyncEngine';
import { startNetworkWatcher } from '../lib/network';

// Ask the browser to pin our storage so it can't be evicted on disk-pressure
// or the iOS 7-day non-use eviction. Best-effort: Safari <17 and private
// browsing may deny; we don't block anything on failure.
async function requestPersistentStorage(): Promise<void> {
  if (typeof navigator === 'undefined' || !navigator.storage?.persist) return;
  try {
    const already = await navigator.storage.persisted();
    if (already) return;
    await navigator.storage.persist();
  } catch (err) {
    // intentional : si l'API n'est pas dispo, on continue sans bloquer
    void err;
  }
}

/**
 * Mounts once inside the SignedIn tree. Configures SyncEngine and CacheWarmer
 * with Clerk's token provider, starts the drain loop + periodic cache warming,
 * and wires the network watcher.
 */
export function SyncBootstrap() {
  const { getToken } = useAuth();
  useEffect(() => {
    const provider = () => getToken();
    SyncEngine.configure(provider);
    SyncEngine.start();
    CacheWarmer.configure(provider);
    CacheWarmer.start();
    void requestPersistentStorage();
    const stopNet = startNetworkWatcher();
    return () => {
      SyncEngine.stop();
      CacheWarmer.stop();
      stopNet();
    };
  }, [getToken]);
  return null;
}
